export const GOOGLE_STATIC_MAPS_KEY = 'AIzaSyBVvRYGnSTIFppjaVB_qmdi8Enl5suNW4s';
export const HELP_CENTER_URL = 'https://help.volusion.com';
export const VOLUSION_CONTACT_URL = 'https://www.volusion.com/contact/';
// eslint-disable-next-line max-len
export const HELP_PURCHASING_CUSTOM_DOMAIN_URL = 'https://www.godaddy.com/help/dive-in-browse-essential-articles-list-26986?isc=gofd2001aj&gclid=EAIaIQobChMIh6OJtYL_6AIVU5JbCh36HwKWEAAYASAAEgIwyfD_BwE&gclsrc=aw.ds';
export const RELEASE_NOTES_URL = 'https://help.volusion.com/release-notes';
export const STATUS_PAGE_URL = 'https://volusion2.statuspage.io';
export const LOGO_URL = '//d3ggqrmoaaez04.cloudfront.net/images/logos/logo.svg';
export const LOGO_SYMBOL_URL = '//d3ggqrmoaaez04.cloudfront.net/images/logos/logo_symbol.svg';
export const LOGO_SYMBOL_LIGHT_URL = '//d3ggqrmoaaez04.cloudfront.net/images/logos/logo_symbol_light.svg';
export const LOGO_USPS = '/assets/usps-icon.svg';
export const LOGO_UPS = '/assets/ups-icon.svg';
export const LOGO_FEDEX = '/assets/fedex-icon.svg';
export const LOGO_DHL = '/assets/dhl-icon.svg';
export const ROOT_DOMAIN = 'volusion.com';
export const LITE_PRODUCT_LIMIT = 5;
export const STRIPE_ELEMENTS_APPLE_PAY = 'Apple Pay';
export const STRIPE_ELEMENTS_GOOGLE_PAY = 'Google Pay';
export const LIVE_CHAT_CLIENT = '141adc3fc6de37100f4b26f351b5f8a2';
export const AUTH0_TENANT_CLAIM = 'https://api.material.com/tenant';
export const AUTH0_METADATA_CLAIM = 'https://api.material.com/user_metadata';
export const AUTH0_PASSWORD_EXPIRED_CLAIM = 'https://api.material.com/password_expired';
export const IMPORTER_TYPES = {
    ORDER: 'order',
    PRODUCT: 'product',
    CUSTOMER: 'customer'
};
export const YOTPO_APP_KEY = 'ZHjSUsdLwpPReKPO41FDgnQd5Tk0hcphahtH9cdlwYn1W2mWBvQ6WmyJS617uIXpsPHq0YQUFKSVTBVAAUGsWA';
export const LOGIN_REDIRECT_COOKIE = 'loginredirect';
export const LOGIN_PASSWORD_EXPIRED_COOKIE = 'loginpasswordexpired';
export const DEFAULT_COUNTRY_CODE = 'US';
export const ADDRESS_COUNTRY = 'Country';
export const ADDRESS_REGION = 'Region';
export const ADDRESS_REGION_PLURAL = 'Regions';

export const PHONE_NUM_MIN = 9;
export const PHONE_NUM_MAX = 17;

export const RESTRICTED_PLANS = [
    process.env.VONAGE_PERSONAL_PLAN_ID,
    process.env.VONAGE_PROFESSIONAL_PLAN_ID,
    process.env.VONAGE_BUSINESS_PLAN_ID
];

export const CATEGORY_SELECTION_ACTIONS = {
    ADD: 'add',
    REMOVE: 'remove'
};

export const STATES_US = {
    AL: 'Alabama',
    AK: 'Alaska',
    AS: 'American Samoa',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District Of Columbia',
    FM: 'Federated States Of Micronesia',
    FL: 'Florida',
    GA: 'Georgia',
    GU: 'Guam',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MH: 'Marshall Islands',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    MP: 'Northern Mariana Islands',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PW: 'Palau',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VI: 'Virgin Islands',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming'
};

export const COUNTRIES = [
    {
        id: 234,
        name: 'United States',
        stateLabel: 'State',
        states: [
            {
                id: 1,
                name: 'Alabama',
                code: 'AL'
            },
            {
                id: 2,
                name: 'Alaska',
                code: 'AK'
            },
            {
                id: 3,
                name: 'Arizona',
                code: 'AZ'
            },
            {
                id: 4,
                name: 'Arkansas',
                code: 'AR'
            },
            {
                id: 5,
                name: 'California',
                code: 'CA'
            },
            {
                id: 6,
                name: 'Colorado',
                code: 'CO'
            },
            {
                id: 7,
                name: 'Connecticut',
                code: 'CT'
            },
            {
                id: 8,
                name: 'Delaware',
                code: 'DE'
            },
            {
                id: 52,
                name: 'District of Columbia',
                code: 'DC'
            },
            {
                id: 9,
                name: 'Florida',
                code: 'FL'
            },
            {
                id: 10,
                name: 'Georgia',
                code: 'GA'
            },
            {
                id: 11,
                name: 'Hawaii',
                code: 'HI'
            },
            {
                id: 12,
                name: 'Idaho',
                code: 'ID'
            },
            {
                id: 13,
                name: 'Illinois',
                code: 'IL'
            },
            {
                id: 14,
                name: 'Indiana',
                code: 'IN'
            },
            {
                id: 15,
                name: 'Iowa',
                code: 'IA'
            },
            {
                id: 16,
                name: 'Kansas',
                code: 'KS'
            },
            {
                id: 17,
                name: 'Kentucky',
                code: 'KY'
            },
            {
                id: 18,
                name: 'Louisiana',
                code: 'LA'
            },
            {
                id: 19,
                name: 'Maine',
                code: 'ME'
            },
            {
                id: 20,
                name: 'Maryland',
                code: 'MD'
            },
            {
                id: 21,
                name: 'Massachusetts',
                code: 'MA'
            },
            {
                id: 22,
                name: 'Michigan',
                code: 'MI'
            },
            {
                id: 23,
                name: 'Minnesota',
                code: 'MN'
            },
            {
                id: 24,
                name: 'Mississippi',
                code: 'MS'
            },
            {
                id: 25,
                name: 'Missouri',
                code: 'MO'
            },
            {
                id: 26,
                name: 'Montana',
                code: 'MT'
            },
            {
                id: 27,
                name: 'Nebraska',
                code: 'NE'
            },
            {
                id: 28,
                name: 'Nevada',
                code: 'NV'
            },
            {
                id: 29,
                name: 'New Hampshire',
                code: 'NH'
            },
            {
                id: 30,
                name: 'New Jersey',
                code: 'NJ'
            },
            {
                id: 31,
                name: 'New Mexico',
                code: 'NM'
            },
            {
                id: 32,
                name: 'New York',
                code: 'NY'
            },
            {
                id: 33,
                name: 'North Carolina',
                code: 'NC'
            },
            {
                id: 34,
                name: 'North Dakota',
                code: 'ND'
            },
            {
                id: 35,
                name: 'Ohio',
                code: 'OH'
            },
            {
                id: 36,
                name: 'Oklahoma',
                code: 'OK'
            },
            {
                id: 37,
                name: 'Oregon',
                code: 'OR'
            },
            {
                id: 38,
                name: 'Pennsylvania',
                code: 'PA'
            },
            {
                id: 39,
                name: 'Rhode Island',
                code: 'RI'
            },
            {
                id: 40,
                name: 'South Carolina',
                code: 'SC'
            },
            {
                id: 41,
                name: 'South Dakota',
                code: 'SD'
            },
            {
                id: 42,
                name: 'Tennessee',
                code: 'TN'
            },
            {
                id: 43,
                name: 'Texas',
                code: 'TX'
            },
            {
                id: 44,
                name: 'Utah',
                code: 'UT'
            },
            {
                id: 45,
                name: 'Vermont',
                code: 'VT'
            },
            {
                id: 46,
                name: 'Virginia',
                code: 'VA'
            },
            {
                id: 47,
                name: 'Washington',
                code: 'WA'
            },
            {
                id: 48,
                name: 'West Virginia',
                code: 'WV'
            },
            {
                id: 49,
                name: 'Wisconsin',
                code: 'WI'
            },
            {
                id: 50,
                name: 'Wyoming',
                code: 'WY'
            }
        ]
    }
];

export const ADMINISTRATIVE_AREA_LEVEL_1_LABELS = {
    US: 'State',
    MX: 'State',
    AU: { singular: 'State/Territory', plural: 'States/Territories' },
    MY: { singular: 'State/Territory', plural: 'States/Territories' },
    CN: 'Province',
    CA: 'Province',
    IT: 'Province',
    ID: 'Province',
    DZ: 'Province',
    TH: 'Province',
    UZ: 'Province',
    EG: 'Governorate',
    AE: 'Emirate',
    BR: 'State'
};

export const ALLOWED_TAGS = [
    '<a>',
    '<audio>',
    '<b>',
    '<big>',
    '<blockquote>',
    '<br>',
    '<cite>',
    '<code>',
    '<dd>',
    '<del>',
    '<div>',
    '<dl>',
    '<dt>',
    '<em>',
    '<embed>',
    '<figcaption>',
    '<figure>',
    '<h1>',
    '<h2>',
    '<h3>',
    '<h4>',
    '<h5>',
    '<h6>',
    '<hr>',
    '<i>',
    '<iframe>',
    '<img>',
    '<label>',
    '<li>',
    '<mark>',
    '<object>',
    '<ol>',
    '<p>',
    '<param>',
    '<pre>',
    '<small>',
    '<span>',
    '<strike>',
    '<strong>',
    '<sub>',
    '<sup>',
    '<table>',
    '<tbody>',
    '<td>',
    '<tfoot>',
    '<th>',
    '<thead>',
    '<tr>',
    '<u>',
    '<ul>',
    '<video>'
];



// WEBPACK FOOTER //
// ./src/app/constants.js